import type { TupleToUnion } from 'type-fest'

export const fontFamily = ['sans', 'heading'] as const
export type FontFamily = TupleToUnion<typeof fontFamily>

export const fontFamilyMap: Record<FontFamily, string> = {
  heading: 'font-heading',
  sans: 'font-sans',
}
